import AuthFlow from "./AuthFlow";

export default function SignIn() {
    return <AuthFlow />;
}
